module.exports = __webpack_public_path__ + "static/media/narwhal.d06686b2.svg";